var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Tracker = /** @class */ (function () {
    function Tracker() {
        this.EVENT_URL = (typeof EVENT_URL !== 'undefined' && EVENT_URL) ? EVENT_URL : 'abtest/event';
    }
    Tracker.prototype.attachStorage = function (storage, experimentName) {
        this.storage = storage;
        this.experimentName = experimentName;
    };
    Tracker.prototype.sendEvent = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var loc, meta, params_1, usp, token, existingLock, _1, resolveLock_1, rejectLock_1, lockPromise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Enrich metadata with location details if running in browser and not already provided.
                        try {
                            if (typeof window !== 'undefined' && window.location) {
                                loc = window.location;
                                meta = payload.metadata || {};
                                if (meta.page == null)
                                    meta.page = loc.pathname;
                                if (meta.fullUrl == null)
                                    meta.fullUrl = loc.href;
                                if (meta.queryString == null)
                                    meta.queryString = loc.search;
                                if (meta.queryParams == null) {
                                    params_1 = {};
                                    if (loc.search.startsWith('?')) {
                                        usp = new URLSearchParams(loc.search);
                                        usp.forEach(function (v, k) { params_1[k] = v; });
                                    }
                                    meta.queryParams = params_1;
                                }
                                payload.metadata = meta;
                            }
                        }
                        catch ( /* ignore enrichment errors */_b) { /* ignore enrichment errors */ }
                        if (!(this.storage && this.experimentName)) return [3 /*break*/, 10];
                        token = this.storage.get(this.experimentName, 'token');
                        if (!!token) return [3 /*break*/, 10];
                        existingLock = Tracker._tokenInitLocks.get(this.experimentName);
                        if (!existingLock) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, existingLock];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 10];
                    case 5:
                        lockPromise = new Promise(function (res, rej) { resolveLock_1 = res; rejectLock_1 = rej; });
                        Tracker._tokenInitLocks.set(this.experimentName, lockPromise);
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, , 8, 9]);
                        return [4 /*yield*/, this._doSend(payload, resolveLock_1, rejectLock_1)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        Tracker._tokenInitLocks.delete(this.experimentName);
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                    case 10: return [4 /*yield*/, this._doSend(payload)];
                    case 11:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Internal low-level send. If a token exists it is included, otherwise the server
     * will generate and return one which we persist (if storage attached).
     */
    Tracker.prototype._doSend = function (payload, resolveLock, rejectLock) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, existingToken, response, ct, data, parseErr_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        headers = { 'Content-Type': 'application/json' };
                        if (this.storage && this.experimentName) {
                            existingToken = this.storage.get(this.experimentName, 'token');
                            if (existingToken)
                                headers['X-Event-Token'] = existingToken;
                        }
                        return [4 /*yield*/, fetch(this.EVENT_URL, {
                                method: 'POST',
                                headers: headers,
                                body: JSON.stringify(payload),
                            })];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 2];
                        console.error('Failed to send event ', response.status);
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(this.storage && this.experimentName)) return [3 /*break*/, 6];
                        ct = response.headers.get('content-type') || '';
                        if (!ct.includes('application/json')) return [3 /*break*/, 6];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, response.json()];
                    case 4:
                        data = _a.sent();
                        if (data && typeof data.token === 'string' && data.token.length) {
                            // Persist token for this experiment so future events attach it.
                            this.storage.set(this.experimentName, 'token', data.token);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        parseErr_1 = _a.sent();
                        // Non-fatal; log once in dev environments.
                        if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
                            console.warn('Failed to parse event response JSON', parseErr_1);
                        }
                        return [3 /*break*/, 6];
                    case 6:
                        if (resolveLock)
                            resolveLock();
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        if (rejectLock)
                            rejectLock(e_1);
                        console.error(e_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Tracker._tokenInitLocks = new Map();
    return Tracker;
}());
export default Tracker;
